import { Grid } from '@mui/material';
import { Location } from '@nx-smartmonkey/shared/domain';
import { useState } from 'react';
import { useRetrieveActiveLanguage } from '../../../hooks/translations/useRetrieveActiveLanguage';
import Button from '../../../react-components/Button';
import { InputLocation } from '../../../react-components/InputLocation';
import { Text } from '../../../react-components/Text';
import { getLocationFromCoordinates } from '../../../services/requests';
import { NewCoordsProps, usePosition } from '../../app/hooks/position/usePosition';

interface RegisterLocationProps {
  location?: Location;
  disabled?: boolean;
  nextStep: (location: Location) => void;
}

export const RegisterLocation = ({ location: initialLocation, disabled, nextStep }: RegisterLocationProps) => {
  const [location, setLocation] = useState<Location | undefined>(initialLocation);
  const { activeLanguage } = useRetrieveActiveLanguage();

  const updateLocation = async ({ lat, lng }: { lat: number; lng: number }) => {
    const locations = await getLocationFromCoordinates({
      coordinates: [{ lat, lng }],
      lang: activeLanguage,
    });
    if (locations.length > 0) {
      setLocation(locations[0]);
    }
  };

  const { setIsTracking } = usePosition({
    onNewCoords: (newCoords: NewCoordsProps) => updateLocation({ lat: newCoords.latitude, lng: newCoords.longitude }),
  });

  return (
    <Grid container flexDirection="column" justifyContent="space-between" flexGrow="1">
      <Grid container flexDirection="column" flexGrow="1" flexWrap="nowrap">
        <Text intlId="auth.register.location" variant="h6" style={{ marginBottom: `24px`, textAlign: `center` }} />
        <InputLocation
          disabled={disabled}
          fieldValue={location}
          onUpdate={(location) => setLocation(location ?? undefined)}
          placeholderIntlId={`auth.register.location.ph`}
        />
      </Grid>

      <Button
        disabled={!location || disabled}
        onClick={() => {
          if (nextStep) {
            setIsTracking(false);
            nextStep(location!);
          }
        }}
        intlId="drivers.register.next"
        style={{
          fontSize: `14px`,
          fontWeight: 400,
        }}
      />
    </Grid>
  );
};
